/*! lozad.js - v1.9.0 - 2019-02-09
* https://github.com/ApoorvSaxena/lozad.js
* Copyright (c) 2019 Apoorv Saxena; Licensed MIT */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.lozad=e()}(this,function(){"use strict";var g=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(t[o]=r[o])}return t},n="undefined"!=typeof document&&document.documentMode,l={rootMargin:"0px",threshold:0,load:function(t){if("picture"===t.nodeName.toLowerCase()){var e=document.createElement("img");n&&t.getAttribute("data-iesrc")&&(e.src=t.getAttribute("data-iesrc")),t.getAttribute("data-alt")&&(e.alt=t.getAttribute("data-alt")),t.appendChild(e)}if("video"===t.nodeName.toLowerCase()&&!t.getAttribute("data-src")&&t.children){for(var r=t.children,o=void 0,a=0;a<=r.length-1;a++)(o=r[a].getAttribute("data-src"))&&(r[a].src=o);t.load()}t.getAttribute("data-src")&&(t.src=t.getAttribute("data-src")),t.getAttribute("data-srcset")&&t.setAttribute("srcset",t.getAttribute("data-srcset")),t.getAttribute("data-background-image")&&(t.style.backgroundImage="url('"+t.getAttribute("data-background-image")+"')"),t.getAttribute("data-toggle-class")&&t.classList.toggle(t.getAttribute("data-toggle-class"))},loaded:function(){}};
/**
   * Detect IE browser
   * @const {boolean}
   * @private
   */function f(t){t.setAttribute("data-loaded",!0)}var b=function(t){return"true"===t.getAttribute("data-loaded")};return function(){var r,o,a=0<arguments.length&&void 0!==arguments[0]?arguments[0]:".lozad",t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},e=g({},l,t),n=e.root,i=e.rootMargin,d=e.threshold,c=e.load,u=e.loaded,s=void 0;return window.IntersectionObserver&&(s=new IntersectionObserver((r=c,o=u,function(t,e){t.forEach(function(t){(0<t.intersectionRatio||t.isIntersecting)&&(e.unobserve(t.target),b(t.target)||(r(t.target),f(t.target),o(t.target)))})}),{root:n,rootMargin:i,threshold:d})),{observe:function(){for(var t=function(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:document;return t instanceof Element?[t]:t instanceof NodeList?t:e.querySelectorAll(t)}(a,n),e=0;e<t.length;e++)b(t[e])||(s?s.observe(t[e]):(c(t[e]),f(t[e]),u(t[e])))},triggerLoad:function(t){b(t)||(c(t),f(t),u(t))},observer:s}}});


/*< lazy load lib */
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    var visible = true;
    if( $(this).css("display") == "none" ) visible = false;
    return elementBottom > viewportTop && elementTop < viewportBottom && visible;
  };

  String.prototype.intVal = function () {
    var intval = this.replace ( /[^\d.]/g, '' );
    if(intval)
      return parseInt(intval);
    return false;
  };

  function lazyloadImg(){
    $('img').each(function(){
      if($(this).isInViewport() && ($(this).hasClass('bc-lazyload')|| $(this).hasClass('lozad'))  && !$(this).hasClass('bc-loading')){
        if($(this).attr('srcset-lazy'))
          $(this).attr('src',getSizedImage($(this))).addClass('bc-lazyloaded').removeClass('bc-lazyload');
        else if($(this).attr('data-src'))
          $(this).attr('src',$(this).attr('data-src')).addClass('bc-lazyloaded').removeClass('lozad');
        else
          $(this).attr('src',$(this).attr('data-lazy-src')).addClass('bc-lazyloaded').removeClass('bc-lazyload');
      }
    });
    $('iframe').each(function(){
      if($(this).isInViewport() && $(this).hasClass('bc-lazyload') && !$(this).hasClass('bc-loading')){
        $(this).attr('src',$(this).attr('data-src')).addClass('bc-lazyloaded').removeClass('bc-lazyload');
      }
    });
    $('.bg-img').each(function(){
      if($(this).isInViewport() && $(this).hasClass('bc-lazyload') && !$(this).hasClass('bc-loading')){
        $(this).css('background-image','url('+$(this).attr('data-src')+')').addClass('bc-lazyloaded').removeClass('bc-lazyload');
      }
    });
  }

  function lazyLoadAsset(src,isScript,delay)
  {
    setTimeout(function(){
      if(isScript)
      {
        var resource = document.createElement('script'); 
        resource.defer = "true";
        resource.src = src;
        var script = document.getElementsByTagName('script')[0];
        script.parentNode.insertBefore(resource, script);  
      }
      else
      {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = src;
        document.head.appendChild(link);
      }
    },delay);
  }

  function getSizedImage(elem)
  {
    var imgSize = 0;
    var imgSrc = '';
    $.each(elem.attr('sizes').split(','),function(index,sizes){
      var sizeArr = sizes.trim().split(')');
//       console.log('img',sizeArr);
      if(sizeArr[0].intVal() >= $(window).width())
      {
        imgSize = sizeArr[1]?sizeArr[1].intVal():sizeArr[0].intVal();
        return false;
      }
      imgSize = sizeArr[1]?sizeArr[1].intVal():sizeArr[0].intVal();
    });

    $.each(elem.attr('srcset-lazy').split(','),function(index,images){
      var imageArr = images.trim().split(' ');
      if(imageArr[1].intVal() >= imgSize)
      {
        imgSrc = imageArr[0].trim();
        return false;
      }
    });
    return imgSrc;
  }

  //< Init lazy load
  $(document).ready(function() {
    lazyloadImg();
    window.addEventListener('scroll', function (event) {
      lazyloadImg();
    }, false);
  });
/*> lazy load lib */


//< lazy load assets
  $(document).ready(function() {
    lazyLoadAsset('https://config.gorgias.io/production/GyBLV6kvqjxNbQkK/chat/ZPB9rx1B3z6WVa3O.js',true,10000);
    
    lazyLoadAsset('https://a.klaviyo.com/media/js/analytics/analytics.js',true,10000);
    lazyLoadAsset('https://cdn-widgetsrepository.yotpo.com/v1/loader/k0L0W2IihKanGL-go-0TvA',true,10000); //added
    lazyLoadAsset('https://staticw2.yotpo.com/WOEGYpZL23aoUxJaaN9umNFO28T3vYnkBTcqSTUC/widget.js',true,10000);
    lazyLoadAsset('https:\/\/revenuebump.com\/AddonApp\/priorityproduct.php?shop=bodycandy-2.myshopify.com\u0026shop=bodycandy-2.myshopify.com',true,10000); //added
    lazyLoadAsset('https:\/\/assets.smartwishlist.webmarked.net\/static\/v6\/smartwishlist2.js?shop=bodycandy-2.myshopify.com',true,10000); //added
    lazyLoadAsset('https:\/\/revenuebump.com\/PriorityOrderApp\/frontview\/boostorder?shop=bodycandy-2.myshopify.com\u0026shop=bodycandy-2.myshopify.com',true,10000); //added
    //lazyLoadAsset("//www.bodycandy.com/cdn/shop/t/150/assets/ajaxcartstyles.scss.css?v=83176099854343745071663046785",false,1000);
  });
//> lazy load assets


//< Mobile Menu
  $('#NavDrawer .hasDrpdown .menuLink').click(function(e){
    e.preventDefault();
    var alreadyActive = $(this).parent().hasClass('active');
    $('#NavDrawer .menuLinkWrap').removeClass('active');
    if(!alreadyActive)
      $(this).parent().addClass('active');
  });
//> Mobile Menu



//< Script added by Throttle Up to restore a pending cart if there's any
  try {
    let pending_cart = getCookie('pending_cart');
    if (pending_cart !== '') {
      setCookie('cart', pending_cart, 14);
      setCookie('pending_cart', '', 14);
      window.location.reload();
    }
  } catch (e) {
    console.log('Could not restore pending cart.');
  }

  function setCookie(cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
//> Script added by Throttle Up to restore a pending cart if there's any


//< wish list code
  $(window).load(function(){
    $('.wishlistbodycontainer .row.products #bookmarks .product .addbutton').unbind('click').removeClass('addsingleproduct').addClass('wishlistprd');
  });
//< wish list code


//< Modal
  $('[data-modal-trigger]').on({
    click:
      function() {
        var $that = $(this),
          modal = $that.attr('data-modal-trigger'),
          $modal = $('[data-modal="' + modal + '"]');

        $modal.show();
      }
  });

  $('[data-modal-trigger="mobile-filters"]').on({
    click:
      function() {
        var $that = $(this),
          modal = $that.attr('data-modal-trigger'),
          $modal = $('[data-modal="' + modal + '"]');

        if ($modal.is(":visible")) {
          $('.js-mobile-menu-trigger').hide();
        }
      }
  });

  $(document.body).on('click', '.js-modal-close', function(e) {
    e.preventDefault();
    $(this).closest('.modal-container').hide();

    $('.js-mobile-menu-trigger').show();
  });

//> Modal


// $(document).on('click','#CartContainer .crt-btn',function(){
// 	console.log('CartContainer console',$(this).parent().attr('id'));
// });

// customAov Inst Popup
$(document).on('click touchend', ".customAovWrap .aovPopupTrigger", function(evt) {
  console.log('aovPopupTrigger');
  $( "#customAovInst" ).dialog({
    minWidth: 200,
    width: 500,
    close: function( event, ui ) {
      $('body').removeClass('beforeOverlay');
    },
    open: function(event, ui) {
      $('body').addClass('beforeOverlay');
    },
//     buttons: [
//       {
//         text: "Close",
//         click: function() {
//           $( this ).dialog( "close" );
//           $('body').removeClass('beforeOverlay');
//         }
//       }
//     ]
  });
});
$(document).on('click',"body.beforeOverlay", function(e) {
  if (e.target !== this)
    return;

  if($( "#personalizedInstruc" ).dialog( "isOpen" ))
    $( "#personalizedInstruc" ).dialog( "close" );
  if($( "#customAovInst" ).dialog( "isOpen" ))
    $( "#customAovInst" ).dialog( "close" );
});


$(window).load(function(){
  // reviews prd page
  var reviewTimer = setInterval(function(){
    if($('.reviewCont .sr-only').length){
      $('.reviewCont .reviewAvg').html($('.reviewCont .sr-only').html().replace('star rating','')+'Stars');
      $('.reviewCont .totalReviews').html($('.reviewCont .text-m').html().replace(' Reviews',''));
      clearInterval(reviewTimer);
    }
  },600);
});